import script from "./RoomStateView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomStateView.vue?vue&type=script&setup=true&lang=ts"

import "./RoomStateView.vue?vue&type=style&index=0&id=041ef326&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041ef326"]])

export default __exports__